"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const google_tag_manager_1 = tslib_1.__importDefault(require("./google-tag-manager"));
exports.default = google_tag_manager_1.default;
//# sourceMappingURL=index.js.map